import React from "react";
import {LogoVisaIcon} from "../../../../../../../assets/svg/logo-visa.icon";
import {CardNetworkModel} from "./card-network.model";
import {CardNetworksEnum} from "../../payment-method-codes.enum";
import {ICardNetworkIconOptions} from "./card-network.view-model.interface";

export class VisaNetworkModel extends CardNetworkModel {
    constructor() {
        super(CardNetworksEnum.Visa);
    }

    get name(): string {
        return "Visa";
    }

    renderIcon(options?: ICardNetworkIconOptions): React.ReactElement | null {
        return (<LogoVisaIcon {...options}/>);
    }
}